import { render, staticRenderFns } from "./fs-popper.vue?vue&type=template&id=11797744&scoped=true"
import script from "./fs-popper.vue?vue&type=script&lang=js"
export * from "./fs-popper.vue?vue&type=script&lang=js"
import style0 from "./fs-popper.vue?vue&type=style&index=0&id=11797744&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11797744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11797744')) {
      api.createRecord('11797744', component.options)
    } else {
      api.reload('11797744', component.options)
    }
    module.hot.accept("./fs-popper.vue?vue&type=template&id=11797744&scoped=true", function () {
      api.rerender('11797744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/poppers/fs-popper.vue"
export default component.exports